module.exports = __webpack_public_path__ + "img/ads2.20e24ce.svg";